/* eslint-disable max-len */
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { createContext, useContext } from 'react';

export const emptyEnrolment = {
  educations: [],
  faculties: [],
  campuses: [],
};

export const EnrolmentContext = createContext<IStudentEnrolment>(emptyEnrolment);
export const useEnrolmentContext = (): IStudentEnrolment => useContext(EnrolmentContext);

export const AffiliationContext = createContext<IAffiliation[]>([]);
export const useAffiliationContext = (): IAffiliation[] => useContext(AffiliationContext);

export const CriticalErrorContext = createContext<FetchBaseQueryError | SerializedError | undefined>(undefined);
export const useCriticalErrorContext = (): FetchBaseQueryError | SerializedError | undefined => useContext(CriticalErrorContext);

export const ImpersonationContext = createContext<{ isStudent: boolean, isApplicant: boolean, isImpersonator: boolean, canViewedUserBeImpersonated: boolean }>({
  isStudent: false,
  isApplicant: false,
  isImpersonator: false,
  canViewedUserBeImpersonated: false,
});
export const useImpersonationContext = (): { isStudent: boolean, isApplicant: boolean, isImpersonator: boolean, canViewedUserBeImpersonated: boolean } => useContext(ImpersonationContext);

export const StudentCardEnabledContext = createContext<boolean>(false);
export const useStudentCardEnabledContext = (): boolean => useContext(StudentCardEnabledContext);

export const MigrationStatusContext = createContext<IMigrationStatus | undefined>(undefined);
export const useMigrationStatusContext = (): IMigrationStatus | undefined => useContext(MigrationStatusContext);

export const ApplicationsContext = createContext<IApplication[]>([]);
export const useApplicationsContext = (): IApplication[] => useContext(ApplicationsContext);
